import {
  ApiListenRejectedReason,
  ApiListenRejectedReasonToListenRejectedReason,
  ListenRejectedReason,
  ListenRejectedReasons,
} from '@/constants';
import {
  ComplianceType,
  Episode,
  EpisodeCard,
  Plan,
  PurchaseType,
} from '@/types';
import { getIsEpisodeEthics } from '@/utils';

export const isChapterCompleted = ({
  currentTime,
  duration,
}: {
  currentTime: number;
  duration: number;
}) => {
  return duration - currentTime < 30;
};

export const getListenRejectReason = ({
  apiReason,
  episode,
  plan,
  compliance,
}: {
  apiReason?: ApiListenRejectedReason;
  episode?: Episode | EpisodeCard;
  plan?: Plan;
  compliance?: ComplianceType;
}): ListenRejectedReason => {
  if (apiReason && apiReason in ApiListenRejectedReasonToListenRejectedReason) {
    return ApiListenRejectedReasonToListenRejectedReason[apiReason];
  }

  if (!episode || !plan || !compliance) {
    return ListenRejectedReasons.UNKNOWN;
  }

  if (plan.purchaseType === PurchaseType.FREE_TRIAL && episode.isPremium) {
    return ListenRejectedReasons.PREMIUM_LOCKED;
  }

  if (
    plan.purchaseType === PurchaseType.FREE_TRIAL &&
    getIsEpisodeEthics({ episode, compliance })
  ) {
    return ListenRejectedReasons.ETHICS_LOCKED;
  }

  if (plan.usageRemaining === 0) {
    return ListenRejectedReasons.PLAN_USED_UP;
  }

  if (plan.validUntil && new Date(plan.validUntil) < new Date()) {
    return ListenRejectedReasons.PLAN_EXPIRED;
  }

  return ListenRejectedReasons.UNKNOWN;
};
